Ext.define('SA.ErrorStack', {
    singleton: true,

    constructor() {
        this.queue = [];
        this.enabled = true;
    },

    disable() {
        this.enabled = false;
    },

    show(error) {
        var message = Ext.isString(error) ? error : error.getMessage();

        if (message) {
            this.queue.push(message);
            this.showNext();
        }
    },

    showAlert() {
        var message = Ext.util.Format.nl2br(Ext.util.Format.htmlEncode(this.takeNext())),
            handler = () => this.showNext();

        Ext.widget({xtype: 'alert', title: 'Unexpected Error', message, handler});
    },

    showNext() {
        if (!this.enabled || this.queue.length === 0) {
            return;
        }

        if (!SA.error) {
            this.showAlert();
            return;
        }

        SA.error(this.takeNext());
        this.showNext();
    },

    takeNext() {
        return this.queue.shift();
    }
});
